import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import useApiClient, { apiRoutes } from "../../../../hooks/apiClient";
import EfisModal from "../../../../components/UI/EfisModal/EfisModal";
import useMontarLogica from "./useMontarLogica";

const useExcluirDemonstrativo = ({ setReload, setItensSelecionados }) => {
  const { montarLogica } = useMontarLogica();
  const {
    request: deleteItemRequest,
    isLoading: deleteItemIsLoading,
    data: deleteItemData,
    errors: deleteItemErrors,
  } = useApiClient();

  const [showExcluirConfirm, setShowExcluirConfirm] = useState({
    show: false,
    body: null,
    context: null,
  });

  useEffect(() => {
    if (!deleteItemData && !deleteItemErrors) return;

    if (deleteItemData) {
      setItensSelecionados([]);
      montarLogica(1);
      setReload((prev) => prev + 1);
      toast.success(deleteItemData.result);
    }

    if (deleteItemErrors) {
      toast.error(deleteItemErrors.message);
    }

    setShowExcluirConfirm({ show: false });
  }, [deleteItemData, deleteItemErrors, montarLogica, setReload, setItensSelecionados, setShowExcluirConfirm]);

  const ModalExcluirDemonstrativo = (
    <EfisModal
      title="Atenção! "
      show={showExcluirConfirm.show}
      body={showExcluirConfirm.body}
      loadingConfirmationAction={deleteItemIsLoading}
      closeHandler={() => setShowExcluirConfirm({ show: false })}
      confirmationHandler={() => {
        deleteItemRequest(apiRoutes.fiscalizacao.ocorrencia.excluirListaItensDemonstrativo, showExcluirConfirm.context);
      }}
      primaryLabel="Sim"
      secondaryLabel="Não"
    />
  );

  return {
    ModalExcluirDemonstrativo,
    setShowExcluirConfirm,
  };
};

export default useExcluirDemonstrativo;
